// extracted by mini-css-extract-plugin
module.exports = {"slidern":"styles_slidern__BmZ2A"};